import React from 'react'
import { connect } from 'react-redux'
import queryString from 'query-string'
import { saveJwt, loadDataForDate } from 'core/actions'

import { DatePickerContext } from 'context'

class JwtInjector extends React.Component {
  componentDidMount() {
    const { saveJwt, location, date } = this.props
    const jwt = queryString.parse(location.search).jwt
    console.log('injecting JwtInjector ', jwt)
    saveJwt(jwt)
    loadDataForDate(date)
  }

  render() {
    return <React.Fragment />
  }
}

const JWTComponent = _ => (
  <DatePickerContext.Consumer>
    {({ selectedDate }) => <JwtInjector date={selectedDate} />}
  </DatePickerContext.Consumer>
)

export default connect(_ => ({}), { saveJwt })(JWTComponent)
